import React from 'react';
import { HorizonInterval } from 'src/models/Horizon';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import Form from 'src/components/controls/forms/Form';
import { AnyObject, FormApi } from 'final-form';

interface IHorizonSelectorProps {
    horizonIntervals: Array<HorizonInterval>;
    onUpdateHorizonInterval?: (horizonInterval: HorizonInterval) => void;
    onSelect: (horizonInterval: HorizonInterval) => void;
    onCreateNew: () => void;
    onCancel: () => void;
}

interface IHorizonSelectorState {
    horizonIntervalFilter: string;
    selectedHorizonInterval: HorizonInterval;
}

class HorizonSelector extends React.Component<IHorizonSelectorProps, IHorizonSelectorState> {
    constructor(props: IHorizonSelectorProps) {
        super(props);

        this.state = {
            horizonIntervalFilter: '',
            selectedHorizonInterval: undefined,
        };
    }

    getHorizonIntervalById = (id: number) => {
        return this.props.horizonIntervals.filter((hi: HorizonInterval) => hi.id === id)[0];
    };

    selectExistingHorizonInterval = (horizonIntervalId: number) => {
        const horizonInterval = this.getHorizonIntervalById(horizonIntervalId);
        this.setState({ selectedHorizonInterval: horizonInterval });
        if (this.props.onSelect) {
            this.props.onSelect(horizonInterval);
        }
    };

    filterHorizon = (values: AnyObject, form: FormApi) => {
        this.setState({ horizonIntervalFilter: values.values.horizonIntervalFilter });
    };

    showButtons = () => {
        const style: React.CSSProperties = {
            cursor: 'pointer',
            background: '#6393C1',
            padding: '.5rem 1rem',
            color: 'white',
            display: 'inline-block',
            marginRight: '1rem',
        };

        return (
            <div>
                <span style={style} onClick={this.props.onCreateNew}>
                    Create New Horizon
                </span>
                <span style={style} onClick={this.props.onCancel}>
                    Cancel
                </span>
            </div>
        );
    };

    handleSubmit = (values: AnyObject) => {
        console.log(values);
    };

    modifyHorizonInterval = (intervalId: number) => {
        this.props.onSelect(this.getHorizonIntervalById(intervalId));
        // this.props.onUpdateHorizonInterval(this.getHorizonIntervalById(intervalId));
    };

    uniqueHorizonIntervals = () => {
        if (!this.props.horizonIntervals) {
            return <div>No Horizons Found on Project</div>;
        }

        let intervalStrings = this.props.horizonIntervals.map((horizonInterval: HorizonInterval) => ({
            id: horizonInterval.id,
            text: HorizonInterval.from(horizonInterval).toString(),
        }));

        if (this.state.horizonIntervalFilter) {
            intervalStrings = intervalStrings.filter((interval: { id: number; text: string }) =>
                new RegExp(this.state.horizonIntervalFilter, 'i').test(interval.text)
            );
        }

        const intervals = intervalStrings.map((interval: { id: number; text: string }) => (
            <div
                key={`hi-${interval.id}`}
                style={{ position: 'relative' }}
                className={`horizon-interval-card ${
                    this.state.selectedHorizonInterval && this.state.selectedHorizonInterval.id === interval.id ? 'selected' : ''
                }`}
                onClick={() => this.modifyHorizonInterval(interval.id)}
            >
                <span>{interval.text}</span>
            </div>
        ));

        return (
            <Form onSubmit={() => console.log('submit')} onChange={this.filterHorizon}>
                <FormTextBox name="horizonIntervalFilter" label="Horizon Filter" />
                <div className="horizon-interval-card-wrapper">{intervals}</div>
            </Form>
        );
    };

    render() {
        return (
            <div style={{ width: '900px' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                    Choose horizon definition below or select 'Create New Horizon' to start with an empty definition
                </div>
                {this.uniqueHorizonIntervals()}
                <div className="dlc-form-action-bar">{this.showButtons()}</div>
            </div>
        );
    }
}

export default HorizonSelector;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/AddHorizonComponents/HorizonSelector.tsx